"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isJsonLikeString = exports.hasPiiValues = exports.getApiKeyTail = exports.isBin = exports.isApiKey = exports.isArray = exports.isPlainObject = exports.isString = void 0;
const simple_regex_patterns_1 = require("./simple-regex-patterns");
const isString = (value) => typeof value === 'string';
exports.isString = isString;
const isPlainObject = (item) => {
    return (!!item &&
        typeof item === 'object' &&
        !(0, exports.isArray)(item) &&
        !(item instanceof Date || item instanceof Buffer));
};
exports.isPlainObject = isPlainObject;
const isArray = (value) => Array.isArray(value);
exports.isArray = isArray;
const API_KEY_TAIL_LENGTH = 4;
const API_KEY_ATTR = 'x-api-key';
const isApiKey = (key) => key.includes(API_KEY_ATTR);
exports.isApiKey = isApiKey;
const binList = ['bin', 'binValue', 'cardBin'];
const isBin = (key) => binList.includes(key.trim());
exports.isBin = isBin;
const getApiKeyTail = (apiKey) => {
    const tailStart = apiKey.length - API_KEY_TAIL_LENGTH;
    const tail = apiKey.substring(tailStart);
    return tail.padStart(apiKey.length, '*');
};
exports.getApiKeyTail = getApiKeyTail;
const REGEX_PATTERN_TYPES = Object.keys(simple_regex_patterns_1.simpleRegexPatterns);
const hasPiiValues = (value) => REGEX_PATTERN_TYPES.some((patternType) => value.match(simple_regex_patterns_1.simpleRegexPatterns[patternType]));
exports.hasPiiValues = hasPiiValues;
const isJsonLikeString = (value) => {
    const trimmedValue = value.trim();
    return trimmedValue.length > 0 && ['{', '[', '"'].includes(trimmedValue[0]);
};
exports.isJsonLikeString = isJsonLikeString;
//# sourceMappingURL=utils.js.map